import { Box } from '@vk-hr-tek/ui/Box';
import { Link } from '@vk-hr-tek/ui/Link';
import { Typography } from '@vk-hr-tek/ui/Typography';
import { Icon } from '@vk-hr-tek/ui/Icon';
import { useInject } from '@vk-hr-tek/core/ioc';

import { useSelector, useDispatch } from '../../../app/hooks';
import { selectAuthInstancesWithoutOpenId, redirectToLogin } from '../../slice';
import { Button, Page } from '../../segments';
import { AuthRouterService } from '../../services';

export const AuthList = () => {
  const dispatch = useDispatch();
  const router = useInject(AuthRouterService);
  const authInstances = useSelector(selectAuthInstancesWithoutOpenId);

  const handleGoAdditionalAuth = (id: string) => router.redirectToAuthLogin(id);

  const handleRedirectToLogin = () => dispatch(redirectToLogin());

  return (
    <Page title="Войти другим способом">
      <Box>
        <Box
          alignItems="center"
          justifyContent="center"
          display="flex"
          flexDirection="column"
          gap="24"
          width="100%"
        >
          {authInstances.map((item, i) => {
            if (i === 0) {
              return null;
            }
            if (item.auth_type === 'esia') {
              return (
                <Box
                  py="16"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  border={1}
                  radius="l"
                  borderColor="stroke.primary"
                  width="100%"
                  onClick={() => handleGoAdditionalAuth(item.id || '')}
                  cursor="pointer"
                  key={item.id}
                >
                  <Typography variant="h6">
                    <Box display="flex" gap="8" alignItems="center">
                      <Icon name="vkhrtek_gosuslugi" size="24" />
                      Войти через Госуслуги
                    </Box>
                  </Typography>
                </Box>
              );
            }
            return (
              <Button
                key={item.id}
                fullWidth
                color={item.button_color && `#${item.button_color}`}
                onClick={() => handleGoAdditionalAuth(item.id || '')}
              >
                {item.button_text || 'Войти'}
              </Button>
            );
          })}
        </Box>
        <Box mt="32" display="flex" alignItems="center">
          <Link
            size="small"
            variant="tertiary"
            startIcon={<Icon name="chevron_left" size="16" />}
            onClick={handleRedirectToLogin}
          >
            Вернуться назад
          </Link>
        </Box>
      </Box>
    </Page>
  );
};
